let language = {
  PRODUCT_MANAGER_SUBTOTAL: 'Subtotal',
  PRODUCT_MANAGER_TOTAL: 'Total',
  PRODUCT_MANAGER_ORDERS: 'Orders',
  PRODUCT_MANAGER_UNIT_PRICE: 'Unit Price',
  PRODUCT_MANAGER_QTY: 'Qty',
  PRODUCT_MANAGER_TOTAL_PRICE: 'Total Price',
  PRODUCT_MANAGER_STORE: 'Store',
  PRODUCT_MANAGER_ERROR_104000001: 'The current user does not have permission to operate this resource',
};

export { language }